import React from 'react'
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

class PointsWatchingFiltersDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false
        };
    }

    render() {
        return (
            <>
                <div>
                    <DialogTitle id="form-dialog-title" style={{ width: "70%", display: "flex", justifyContent: "center" }}>
                        Filters
                    </DialogTitle>
                    <DialogContent className={"dialogBox"}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                autoOk
                                name="fromDate"
                                variant="inline"
                                inputVariant="outlined"
                                label="From"
                                format="yyyy-MM-dd"
                                style={{ width: 350, marginBottom: 20 }}
                                value={this.props.fromDate}
                                InputAdornmentProps={{ position: "start" }}
                                onChange={dateInput => {
                                    let date = new Date(dateInput?.toString())
                                    if (date.toString() === "Invalid Date") {
                                        return
                                    }
                                    this.props.handleDateChange(date, 'fromDate')
                                }}
                            />
                        </MuiPickersUtilsProvider>

                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                autoOk
                                name="toDate"
                                variant="inline"
                                inputVariant="outlined"
                                label="To"
                                format="yyyy-MM-dd"
                                style={{ width: 350, marginBottom: 20 }}
                                value={this.props.toDate}
                                InputAdornmentProps={{ position: "start" }}
                                onChange={dateInput => {
                                    let date = new Date(dateInput?.toString())
                                    if (date.toString() === "Invalid Date") {
                                        return
                                    }
                                    date.setHours(19);
                                    date.setMinutes(59);
                                    date.setSeconds(59);
                                    this.props.handleDateChange(date, 'toDate')
                                }
                                }
                            />
                        </MuiPickersUtilsProvider>
                    </DialogContent>

                    <DialogActions style={{ justifyContent: "center", marginBottom: 10 }}>
                        <Button variant='contained' onClick={() => this.props.onClose(false, true)}>Cancel</Button>
                        <Button variant='contained' onClick={() => {
                            this.props.onClose(true, true)
                        }} color="primary">Apply</Button>
                    </DialogActions>

                </div>
            </>
        )
    }
}

export default PointsWatchingFiltersDialog;